const STATE_KEY = 'state';
// Saqlangan holat KIMGA tegishli. Tizimdan chiqilganda ham (clearTemporaryStorage)
// o'chirilmaydi -- shu sabab o'sha akkaunt qaytib kirsa, tugallanmagan hujjatlari joyida qoladi.
const STATE_OWNER_KEY = 'stateOwner';

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(STATE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Loginda chaqiriladi. Saqlangan holat shu foydalanuvchiniki bo'lsa -- tegilmaydi
// (documents-in kabi tugallanmagan ma'lumotlar saqlanib qoladi). Boshqa akkauntniki
// bo'lsa -- o'chiriladi, aks holda yangi akkauntga o'tib ketardi.
// Qaytaradi: holat o'chirildimi (ya'ni redux holatini ham tozalash kerakmi).
export const claimStateFor = (username) => {
  const owner = localStorage.getItem(STATE_OWNER_KEY);
  localStorage.setItem(STATE_OWNER_KEY, username);

  if (owner === username) return false;

  localStorage.removeItem(STATE_KEY);
  return true;
};

// Boshqa oynada boshqa akkaunt kirganda shu oyna holatini saqlashni to'xtatamiz --
// aks holda chiqib ketayotgan oyna yangi akkauntning holatini bosib yozib yuborishi mumkin.
let persistEnabled = true;

export const disableStatePersist = () => {
  persistEnabled = false;
};

export const saveState = (state) => {
  if (!persistEnabled) return;
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STATE_KEY, serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};